import { render, staticRenderFns } from "./FormEmpleados.vue?vue&type=template&id=685ae353&scoped=true&"
import script from "./FormEmpleados.vue?vue&type=script&lang=js&"
export * from "./FormEmpleados.vue?vue&type=script&lang=js&"
import style0 from "./FormEmpleados.vue?vue&type=style&index=0&id=685ae353&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ae353",
  null
  
)

export default component.exports